import { get } from 'lodash/fp';
import { Component } from 'react';

import { maskedValue, NumberMask } from '../masked';
import { MaskedInputProps } from '../maskedInput';

interface NumberInputProps {
    name: string;
    value: string | number;
    numberMask: NumberMask;
    onChange?: (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent, value: string | number) => void;
    shouldReturnMaskedValue?: boolean;
}

export default (MaskedInput: React.ComponentClass<MaskedInputProps>) => {
    class NumberInput extends Component<NumberInputProps> {
        handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.MouseEvent, value: string | number) => {
            const { onChange, numberMask, shouldReturnMaskedValue } = this.props;

            const finalValue = shouldReturnMaskedValue
                ? value
                : get(
                      'value',
                      maskedValue.unmaskValue({ value: value as string, selection: { start: 0, end: 0 } }, numberMask)
                  );

            if (onChange) {
                onChange(e, finalValue);
            }
        };

        render() {
            const { numberMask, value, shouldReturnMaskedValue, ...other } = this.props;
            const unmaskedPropsValue = value.toString();
            const finalValue = shouldReturnMaskedValue
                ? unmaskedPropsValue
                : get('value', maskedValue.maskValue(unmaskedPropsValue, numberMask));

            return (
                <MaskedInput {...other} value={finalValue} onChange={this.handleChange} mask={numberMask} type="tel" />
            );
        }
    }
    return NumberInput;
};
